









































































































import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
// import { Exhibitor } from '@/modules/exhibitor/exhibitor';
import {
  BrandData,
  Exhibitor,
} from 'mostra';

interface DataType {
  descriptionTexts: object;
}

// type DescriptionKind = 'staff';
interface DescriptionTexts {
  staff: string[],
}

const descriptionTexts: DescriptionTexts = {
  staff: [
    '来場者からお問い合わせがあった際に担当者のメールアドレスにご連絡がいきます。',
    'ブランドページに担当者として表示されます。',
  ],
};

export default Vue.extend({
  name: 'GBrandSettingForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brand: {
      type: Object as PropType<BrandData>,
      default: () => ({}),
    },
    exhibitors: {
      type: Array as PropType<Exhibitor[]>,
      default: () => [],
    },
  },
  data(): DataType {
    return {
      descriptionTexts: descriptionTexts,
    };
  },
});
